'use client'

import type { ComponentProps } from 'react'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/localized-breadcrumb'

import { DetailsPage } from '~/components/blog/details-page'
import type { NotionPage } from '~/components/notion-page'
import type { Post } from '~/domains/blog/list-posts'

export const Page = ({
	post,
	recordMap,
}: {
	post: Post
	recordMap: ComponentProps<typeof NotionPage>['recordMap']
}) => {
	return (
		<div className='mx-auto flex w-full max-w-3xl flex-col gap-y-6'>
			<Breadcrumb>
				<BreadcrumbList>
					<HomeBreadcrumbItem />
					<BreadcrumbSeparator />

					<BreadcrumbItem>
						<BreadcrumbLink href='/blog'>Blog</BreadcrumbLink>
					</BreadcrumbItem>

					<BreadcrumbSeparator />

					<BreadcrumbItem className='max-w-sm'>
						<BreadcrumbPage className='justify-start truncate'>
							<span className='truncate'>{post.title}</span>
						</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<DetailsPage
				post={post}
				recordMap={recordMap}
			/>
		</div>
	)
}
